import React from 'react'
import TeamsListing from 'components/Teams/TeamsListing'
import './Teams.scss'

function Teams() {
  return <TeamsListing />
}

export default Teams
